import {useGameState} from '../../hooks/useGameState'
import {includes, toUpper} from 'ramda'
import React from 'react'
import {makeStyles} from '@material-ui/styles'
import Button from '../common/Button'

const DIAMETER = 1.8
const MARGIN = 0.5

const useStyles = makeStyles({
  root: {
    ...createRootStyle(DIAMETER, MARGIN),
    display: 'inline-block',
    padding: 0,
  },
  '@media (orientation: portrait) and (min-height: 481px)': {
    root: createRootStyle(DIAMETER * 1.25, MARGIN),
  },
})

function createRootStyle(diameter, margin) {
  return {
    width: `${diameter}em`,
    height: `${diameter}em`,
    borderRadius: `${diameter}em`,
    margin: `${margin}em`,
  }
}

export default function LetterButton({letter}) {
  const {root} = useStyles()
  const {tryLetter, tries} = useGameState()

  return (
    <Button
      className={root}
      disabled={includes(letter, tries)}
      onClick={() => tryLetter(letter)}
    >
      {toUpper(letter)}
    </Button>
  )
}